import React, { FC } from 'react'
import { Layout } from 'components/Layout'
import { CouponLinkCompleteTemplate } from 'components/Templates'

const CouponLinkComplete: FC = () => {
  return (
    <Layout headline={'クーポン'} iconPath={'/icon/white/coupon.svg'} title={'ユーザー紐付け完了 | クーポン一覧'}>
      <CouponLinkCompleteTemplate />
    </Layout>
  )
}

export default CouponLinkComplete
